import constants from '../helpers/constants.js';
import initialState from './initialState.js';
import _ from 'lodash';

export const SET_PAYER_ADDRESS = 'SET_PAYER_ADDRESS';

export const setPayerAddress = (data) => ({ type: SET_PAYER_ADDRESS, payload: data });

export default function checkoutReducer (state = initialState.checkoutdata, action) {
  switch (action.type) {
    case SET_PAYER_ADDRESS:
      return { ...state, payerAddress: action.payload };
    case constants.CHECKOUT_ITEMS_LIST:
      return  Object.assign({}, state, {items: action.data});
    default:
      return state;
  }
}